export enum PaxOverviewType {
  Past,
  Current,
  Planned,
  CurrentAndPlanned,
}
